import QRCodeStyling from 'qr-code-styling'
import { useEffect, useRef } from 'react'

import { useBrandSquareLogo } from '@shared/hooks'

interface QrCodeProps {
  value: string;
  size?: number;
  className?: string;
}

export default function QrCode ({ value, size = 256, className }: QrCodeProps) {
  const ref = useRef<HTMLDivElement>(null)
  const qrCodeRef = useRef<QRCodeStyling | null>(null)
  const brandLogo = useBrandSquareLogo()

  useEffect(() => {
    if (!qrCodeRef.current) {
      qrCodeRef.current = new QRCodeStyling({
        width: size,
        height: size,
        data: value,
        image: brandLogo ?? undefined,
        qrOptions: {
          errorCorrectionLevel: 'Q'
        },
        dotsOptions: {
          color: '#000000',
          type: 'square'
        },
        cornersSquareOptions: {
          color: '#000000',
          type: 'dot'
        },
        cornersDotOptions: {
          color: '#000000',
          type: 'dot'
        },
        imageOptions: {
          crossOrigin: 'anonymous',
          margin: -4,
          imageSize: 0.2
        },
      })
    }
  }, [ size, value, brandLogo ])

  useEffect(() => {
    const currentRef = ref.current
    
    if (qrCodeRef.current && currentRef) {
      qrCodeRef.current.append(currentRef)
    }

    return () => {
      if (currentRef) {
        currentRef.innerHTML = ''
      }
    }
  }, [])

  useEffect(() => {
    if (qrCodeRef.current && value) {
      qrCodeRef.current.update({ data: value })
    }
  }, [ value ])

  useEffect(() => {
    if (qrCodeRef.current) {
      qrCodeRef.current.update({ 
        width: size, 
        height: size 
      })
    }
  }, [ size ])

  useEffect(() => {
    if (qrCodeRef.current && brandLogo) {
      qrCodeRef.current.update({ 
        image: brandLogo 
      })
    }
  }, [ brandLogo ])

  return <div ref={ref} className={className} />
}